import httpClient from "../http/http-client";
import { IDistributionListAddress, IEditDistributionListAddressGenericTeam, IEditDistributionListAddressIndividualContacts } from './distribution-list-address.model';

export default class DistributionListAddressService {
  http;

  constructor() {
    this.http = httpClient
  }


  async getAddressesForDistributionList(distributionListId: string): Promise<IDistributionListAddress[]> {
    return this.http.get(`distribution-list-address/all-addresses/${distributionListId}`)
      .then(response => {
        return response.data.rows
      })
      .catch(err => {
        console.log(err);
        throw err;
      });
  }

  async getAddressesForDistributionListWithPagination(distributionListId: string, page: number, perPage: number = 10, searchQuery: string, orderBy?: string, order?: 'asc' | 'desc'): Promise<{ count: number, rows: IDistributionListAddress[] }> {
    return this.http.get(`distribution-list-address/all-addresses/${distributionListId}?page=${page}&perPage=${perPage}&nameIncludes=${searchQuery}${order && orderBy ? `&orderBy=${orderBy}&order=${order}` : ''}`)
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err)
        throw err;
      });
  }

  async addDistributionListAddress(distributionList: IEditDistributionListAddressIndividualContacts): Promise<any> {
    return this.http.post(`distribution-list-address/add`, distributionList)
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err);
        throw err;
      });
  }

  async editDistributionListAddress(distributionListAddressId: string, distributionList: IEditDistributionListAddressIndividualContacts | IEditDistributionListAddressGenericTeam): Promise<any> {
    return this.http.post(`distribution-list-address/${distributionListAddressId}/edit`, distributionList)
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err);
        throw err;
      });
  }

  async deleteDistributionListAddress(distributionListAddressId: string): Promise<any> {
    return this.http.post(`distribution-list-address/${distributionListAddressId}/delete`)
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err);
        throw err;
      });
  }

}